<template>
<div>
  <b-modal
      v-model="showUpdateContact"
      type="warn"
      title="Confirm Update"
      @ok="saveContactConfirmed=true; saveContactFn()"
      @cancel="resetData"
      ok-title="Yes, Save"
    >
      <p>Changes made to the contact will be reflected in all media calls it is being used at. Are you sure you want to save the contact?</p>
    </b-modal>
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
    <form @submit.prevent='handleSubmit(saveContactFn)'>
      <div class="row" v-if="contactData">
        <div class="col-md-6">
          <div class="form-group">
            <label>First Name</label>
            <b-form-input type="text" v-model="contactData.first_name" v-on:keyup.enter="saveContactFn" ref="focusThis" lazy-formatter :formatter="Format.titleCase" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Last Name</label>
            <b-form-input type="text" v-model="contactData.last_name" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.titleCase"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
                  <label>Title</label>
                  <b-form-input type="text" v-model="contactData.position" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.titleCase"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>{{deliverableContactCompanyLabel(deliverableDetail.deliverable_template_id)}}</label>
            <b-form-input type="text" v-model="contactData.company_name"  v-on:keyup.enter="saveContactFn"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
                  <label>Email</label>
                  <ValidationProvider rules="email" v-slot="{errors}">
                    <b-form-input type="text" v-model="contactData.email_address"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.email"/>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
            <label>Phone</label>
            <b-form-input type="text" v-model="contactData.phone"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.phone"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Mobile</label>
            <b-form-input type="text" v-model="contactData.cell_phone" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.phone"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Fax</label>
            <b-form-input type="text" v-model="contactData.fax_number" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.phone"/>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>Website</label>
            <b-form-input type="text" v-model="contactData.website"  v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.website"/>
          </div>
        </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>Address</label>
                  <b-form-input type="text" class="form-control" v-model="contactData.address"></b-form-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>City</label>
                  <b-form-input type="text" v-model="contactData.city"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.city"/>
                </div>
              </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Country</label>
            <multiselect
              v-model="contactData.country_id"
              :options="allCountries"
              :multiple="false"
              @input="filterState"
            ></multiselect>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Province</label>
            <multiselect v-model="contactData.province" :options="filteredStates" :multiple="false"></multiselect>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Postal Code</label>
            <b-form-input type="text" v-model="contactData.postal_code"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.postalCode"/>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>Region</label>
            <multiselect v-model="contactData.region" :options="allRegions" :multiple="false"></multiselect>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>Notes</label>
            <b-form-textarea class="form-control" v-model="contactData.notes"></b-form-textarea>
          </div>
        </div>
        <div v-if="$router.currentRoute.name == 'globalSearch'" class="col-md-12">
          <div class="form-group">
            <label>Active: <switches v-model="contactStatus" theme="bootstrap" color="primary"></switches></label>
          </div>
        </div>
        <div class="col-md-12">
                            <div class="row" v-show="showErrorAlert">
                              <div class="col">
                            <b-alert v-model="showErrorAlert" variant="danger">There is a problem with the information entered above.</b-alert>				</div>
                          </div>
          <div class="row">
          <div class="col">
            <button class="btn btn-primary" type="submit" data-dismiss="modal">Save</button>
          </div>
          <div class="col text-right" v-if="$router.currentRoute.name != 'globalSearch'">
            <button class="btn btn-text" type="button" @click="removeContactFn" data-dismiss="modal">Remove from Call</button>
          </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
    </div>
	
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Format from "../../utility/Format"
import Switches from 'vue-switches';
export default {
  data() {
    return {
      contactStatus: 1,
      contactData: false,
      filteredStates: [],
					Format,
          showErrorAlert:false,
          showUpdateContact: false,
          saveContactConfirmed: false
    };
  },
  components: {
    Switches
  },
  computed: {
    ...mapGetters(["allCountries", "allStates", "deliverableDetail", "deliverableContactsLabel", "deliverableContactCompanyLabel", "allRegions"]),
    ...mapState({
      currentContactId: state => state.currentContactId,
      currentFieldKey: state => state.currentFieldKey,
      currentContactData: state => state.currentContactData
    }),
    // contactData() {
    //   let contactData = this.currentContactData;
    //   if(this.$router.currentRoute.name == 'globalSearch') {
    //     if(!contactData) {
    //       contactData = {
    //         id: '',
    //         first_name: '',
    //         last_name: '',
    //         position: '',
    //         company_name: '',
    //         email_address: '',
    //         phone: '',
    //         cell_phone: '',
    //         fax_number: '',
    //         website: '',
    //         address: '',
    //         city: '',
    //         country_id: '',
    //         province: '',
    //         postal_code: '',
    //         region: '',
    //         notes: ''
    //       }
    //     } 
    //   }
      
    //   return contactData;
    //   // return _.find(this.deliverableDetail.contacts, {
    //   //   id: this.currentContactId
    //   // });
    // }
  },
  mounted() {
    let blankContactData = { id: '', first_name: '', last_name: '', position: '', company_name: '', email_address: '', phone: '', cell_phone: '', fax_number: '', website: '', address: '', city: '', country_id: '', province: '', postal_code: '', region: '', notes: '' }
    this.contactData = this.currentContactData ? this.currentContactData : blankContactData
    this.contactStatus = typeof this.contactData != 'undefined' && this.contactData.id == '' ? 1 : this.contactData.is_active
  },
  methods: {
    focusMyElement() {
      if(typeof this.$refs.focusThis != 'undefined') {
        this.$refs.focusThis.focus()
      }
    },
    resetData() {
      let self = this;
      if(self.$router.currentRoute.name == 'globalSearch') {
        let currentPageNumber = localStorage.getItem('currentPageNumber');
        let currentGSTab = localStorage.getItem('currentGSTab');
        self.$store.dispatch('globalSearch', {type: currentGSTab, page: currentPageNumber});
      }
    },
    saveContactFn() {
			if (this) {
        let that = this;
        if(that.$router.currentRoute.name == 'globalSearch' && !that.saveContactConfirmed) {
          if(this.contactData.id != '') {
            this.showUpdateContact = true;
            return;
          } 
        }
				this.$refs.form.validate().then(success => {
					if (!success) {
						that.showErrorAlert = true;
						return;
					}
          that.showErrorAlert = false;
          that.contactData.is_active = that.contactStatus;
          if(that.$router.currentRoute.name == 'globalSearch') {
            that.$store.dispatch("updateContactGS", that.contactData).then(function() {
              if(that.$router.currentRoute.name == 'globalSearch') {
                let currentPageNumber = localStorage.getItem('currentPageNumber');
                let currentGSTab = localStorage.getItem('currentGSTab');
                that.$store.dispatch('globalSearch', {type: currentGSTab, page: currentPageNumber});
                that.$store.dispatch('manageUndoActivation', 'Outlet saved.');
              }
            });
          } else {
					  that.$store.dispatch("updateWho", that.contactData);
          }
					that.$bvModal.hide('editWhoModal')
				});
			}
   },
    removeContactFn() {
      if (this.contactData.id) {
        this.$store.dispatch("removeDeliverableWho", this.contactData.id);
      }
      this.$bvModal.hide('editWhoModal')
    },
    filterState() {
      let allStatesData = this.allStates,
        usStates = allStatesData.slice(0, 50),
        canadaStates = allStatesData.slice(51);
      this.filteredStates =
        this.contactData.country_id == "Canada" ? canadaStates : usStates;
    }
  },
  created() {
    this.filterState();
  }
};
</script>

<style>
</style>